export default __webpack_public_path__ + "static/media/guy-with-mag-glass.284cac2e.svg";